import axios from 'axios'

const getToken = () => {
  if (localStorage.getItem('accessToken')) {
    return localStorage.getItem('accessToken')
  }
  return undefined
}

export const $api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    accessToken: getToken(),
  },
  withCredentials: true,
})

$api.interceptors.request.use(
  async config => {
    config.headers.accessToken = getToken()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
